export class ApplicationLoginContext {
  static readonly Portal = 'Portal';
  static readonly AgentApp = 'AgentApp';
}
